import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function PromoBar() {
  const time = useCountdown();
  return <div className="sticky top-0 z-40 border-b border-ink-line bg-[#070d1a]" data-id="element-180" data-mp="8aqcy0qtiux2">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-2.5 text-sm" data-id="element-181" data-mp="3hx8zf36bqm1">
        <p className="truncate text-cream" data-id="element-182" data-mp="3unyp421zxaej">
          <span className="mr-2 font-bold text-gold" data-id="element-183" data-mp="3umxcht5c0fup">PROMO</span>
          <span className="hidden sm:inline" data-id="element-184" data-mp="3qo6dthl7wq5h">Le Jazz Master + 5 bonus exclusifs — seulement 27 $. L’offre se termine ce soir.</span>
          <span className="sm:hidden" data-id="element-185" data-mp="3lqemopsed82c">Jazz Master + 5 bonus — 27 $</span>
        </p>
        <p className="flex shrink-0 items-center gap-2" data-id="element-186" data-mp="3gph5ogj4ik2f">
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-cream-muted" data-id="element-187" data-mp="3bqxhsakyyy7f">Fin dans</span>
          <span className="font-semibold tabular-nums text-gold" aria-live="off" data-id="element-188" data-mp="1ewt040j0bkjh">{time}</span>
        </p>
      </div>
    </div>;
}